import { render, staticRenderFns } from "./CarteLive.vue?vue&type=template&id=25bcb620&scoped=true&"
import script from "./CarteLive.vue?vue&type=script&lang=js&"
export * from "./CarteLive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25bcb620",
  null
  
)

export default component.exports